import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = (_: Theme) =>
  createStyles({
    // Class keys from Autocomplete
    root: {},
    labelRoot: {},
    labelError: {},
    search: {},
    loading: {},
    notFoundResults: {},
    notFoundText: {},
    actionRow: {},
    textField: {},
    textFieldInput: {},
    list: {},
    optionsList: {},
    listAbove: {},
    listItem: {},
    clearIcon: {},
  });
